// extracted by mini-css-extract-plugin
export default {"wrapper":"EditDesignTemplateItem_wrapper__b-Mj3","text":"EditDesignTemplateItem_text__9MpRe","active":"EditDesignTemplateItem_active__t5ZD8"};